import { render, staticRenderFns } from "./HomeBar.vue?vue&type=template&id=6aa282e7&"
import script from "./HomeBar.vue?vue&type=script&lang=js&"
export * from "./HomeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports